import React from 'react';
import styles from './styles.scss';
const Tooltip = _ref => {
  let {
    children,
    content
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.tooltip
  }, children, /*#__PURE__*/React.createElement("span", {
    className: styles.content,
    "aria-hidden": "true"
  }, content));
};
export default Tooltip;
//# sourceMappingURL=tooltip.js.map